var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 15,
    viewBox: "0 0 4 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 8.3335C2.46007 8.3335 2.83317 7.9604 2.83317 7.50016C2.83317 7.03993 2.46007 6.66683 1.99984 6.66683C1.5396 6.66683 1.1665 7.03993 1.1665 7.50016C1.1665 7.9604 1.5396 8.3335 1.99984 8.3335Z",
    stroke: "#B1B4B2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 2.50016C2.46007 2.50016 2.83317 2.12707 2.83317 1.66683C2.83317 1.20659 2.46007 0.833496 1.99984 0.833496C1.5396 0.833496 1.1665 1.20659 1.1665 1.66683C1.1665 2.12707 1.5396 2.50016 1.99984 2.50016Z",
    stroke: "#B1B4B2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 14.1668C2.46007 14.1668 2.83317 13.7937 2.83317 13.3335C2.83317 12.8733 2.46007 12.5002 1.99984 12.5002C1.5396 12.5002 1.1665 12.8733 1.1665 13.3335C1.1665 13.7937 1.5396 14.1668 1.99984 14.1668Z",
    stroke: "#B1B4B2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.2a585361db0bafa94e7ae5e1c80d2755.svg";
export { ForwardRef as ReactComponent };